<template >
    <img
        v-if="scope.row[config.prop].length != 0"
        :src="`${picAPI}` + scope.row[config.prop][0].url"
        style="max-height:60px;"
    />
    <!-- <span v-if="true">有</span> -->
    <span v-else>无</span>
</template>

<script>
import { PIC_API as picAPI } from '@/utils/common';

export default {
    name:'TImg',
    cName:'图片',
    // functional: true,
    // Props 是可选的
    props: [ 'scope',
      'config',],
    data(){
      return {
        picAPI
      }
    }
     
    
};
</script>
